import { useEffect, useRef, useState } from 'react';
import quantService from '../../../../services/quantService';

// Polls /infra/worker-status/ every `intervalMs` ms.
// Returns { status, instanceId, refresh }.
//
// status values:
//   'idle'         — no spot worker running
//   'pending'      — spot launch requested but instance not yet ready
//   'running'      — spot worker is up and processing
//   'shutting-down'— graceful termination in progress
//   'unknown'      — describe-instances failed (transient AWS error)
//
export default function useQuantWorker(intervalMs = 5000) {
  const [status, setStatus] = useState('idle');
  const [instanceId, setInstanceId] = useState(null);
  const [error, setError] = useState(null);
  const timer = useRef(null);

  const fetchOnce = async () => {
    try {
      const { data } = await quantService.getWorkerStatus();
      setStatus(data.state || 'unknown');
      setInstanceId(data.instance_id || null);
      setError(null);
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    }
  };

  useEffect(() => {
    fetchOnce();
    timer.current = setInterval(fetchOnce, intervalMs);
    return () => timer.current && clearInterval(timer.current);
  }, [intervalMs]);

  return { status, instanceId, error, refresh: fetchOnce };
}
